import getStickySession from 'utils/getStickySession';
import AbstractRequestTask from './AbstractRequestTask';
import Utils from '../../utils/Utils';
import { getHKS } from '../../utils/HKS';
import { getBrowser } from '../../utils/Platform';

class ChangePaymentInfoTask extends AbstractRequestTask {
  constructor(params) {
    super();
    this.params = params;
  }

  passErrorToRequest = true;

  getUrl() {
    const domainMfkw = window.getConfig.url_dominio_microfwk;
    const config = window.getConfig;
    let params = {
      api_version: config.api_version,
      authpn: config.authpn,
      authpt: config.authpt,
      format: 'json',
      region: window.utils.userType.checkRegion(),
      device_id: 'web',
      device_category: 'web',
      device_model: 'web',
      device_type: 'web',
      device_so: getBrowser(),
      device_manufacturer: 'generic',
      HKS: getHKS(),
    };
    const stickySession = getStickySession();
    params = Object.assign({}, params, stickySession);
    return `${domainMfkw}/services/payway/changepaymentinfo?${Utils.buildQueryStringParams(
      params,
    )}`;
  }

  getMethod() {
    return 'POST';
  }

  getParams() {
    return this.params;
  }

  success(data, b) {
    const isValid = super.success(data, b);
    if (!isValid) {
      const newData = super.parseErrors(data);
      return this.reject(newData, b);
    }
    this.resolve(data);
  }
}

export default ChangePaymentInfoTask;
